import compact from 'lodash-es/compact';
import isNil from 'lodash-es/isNil';

import { useCurrentUser } from './useCurrentUser';
import { useUserCoursePurchaseDetailsByIds } from './useUserCoursePurchaseDetailsByIds';

export function useUserWithPurchasedCoursesByIds(
  ids: string[],
  options: Parameters<typeof useUserCoursePurchaseDetailsByIds>[1] = {},
) {
  const { currentUser, loading: loadingUserDetails, error: userError, ...rest } = useCurrentUser();

  const {
    purchasedCourses,
    loading: loadingPurchasedCourses,
    error: errorPurchasedCourses,
  } = useUserCoursePurchaseDetailsByIds(ids, options);

  const userDetailsWIthPurchasedCourses = !isNil(currentUser)
    ? {
        ...currentUser,
        purchased_courses: purchasedCourses.map(course => ({ course: { id: course.course_id } })),
      }
    : null;

  const loading = loadingUserDetails || loadingPurchasedCourses;

  const errors = compact([userError, errorPurchasedCourses]);
  return { currentUser: userDetailsWIthPurchasedCourses, loading, errors, ...rest };
}
